import { Component, OnInit } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {
  lang = localStorage.getItem('lang')

  constructor(private translateService: TranslateService) {
    if (!localStorage.getItem('lang')) {
      localStorage.setItem('lang', 'en')
    }
  }

  ngOnInit(): void {
    this.lang = this.lang ? this.lang : 'en'
    this.translateService.setFallbackLang(this.lang)
    this.translateService.use(this.lang)
    localStorage.setItem('lang', this.lang)
    document
      .getElementsByTagName('html')[0]
      .setAttribute('dir', this.lang === 'ar' ? 'rtl' : 'ltr')
    document
      .getElementsByTagName('body')[0]
      .setAttribute('dir', this.lang === 'ar' ? 'rtl' : 'ltr')
  }
}
